import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FiArrowLeft, FiChevronDown, FiSearch } from 'react-icons/fi';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';

import './styles.css';

export default function Mensagem() {
  const history = useHistory();
  const { t } = useTranslation();
  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const [mensagem, setMensagem] = useState('');
  const [TAGS, setTAGS] = useState(() => {
    try {
      const cached = JSON.parse(sessionStorage.getItem('TAGS'));
      return Array.isArray(cached) ? cached : [];
    } catch (err) {
      return [];
    }
  });
  const [selecionadas, setSelecionadas] = useState([]);
  const [tagsOpen, setTagsOpen] = useState(false);
  const [tagQuery, setTagQuery] = useState('');
  const tagsBoxRef = useRef(null);

  function tagLabel(name) {
    const bruto = String(name || '').trim();
    if (!bruto) return '';
    const comHash = bruto.charAt(0) === '#' ? bruto : `#${bruto}`;
    return comHash.toUpperCase();
  }

  useEffect(() => {
    sessionStorage.setItem('tagsMsg', '');
    api.get('/v4/tags', {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      const data = Array.isArray(response.data) ? response.data : [];
      sessionStorage.setItem('TAGS', JSON.stringify(data));
      setTAGS(data);
    }).catch(() => {});

    function fecharTags(e) {
      if (tagsBoxRef.current && !tagsBoxRef.current.contains(e.target)) {
        setTagsOpen(false);
      }
    }
    document.addEventListener('mousedown', fecharTags);
    return () => document.removeEventListener('mousedown', fecharTags);
  }, [USER_EMAIL, USER_TOKEN]);

  async function enviarMenagem(e) {
    e.preventDefault();
    if (mensagem.length >= 2) {
      var axios = require('axios');
      const tagsMsg = selecionadas.map((el) => el.name);
      var data = JSON.stringify({ description: mensagem, mentions: [], tags: tagsMsg });
      var config = {
        method: 'post',
        url: BASE_URL + '/v4/users/me/posts',
        headers: {
          USER_EMAIL,
          USER_TOKEN,
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
        .then(function () {
          sessionStorage.setItem('tagsMsg', '');
          history.push('/publicacoes');
        })
        .catch(function () {
        });
    }
  }

  function selecionaTag(tagsId) {
    const id = Number(tagsId);
    let vet = [...selecionadas];
    const jaTem = vet.find((tag) => Number(tag.id) === id);
    if (!jaTem) {
      if (vet.length >= 7) {
        alert(t('pages.message.alerts.tags'));
        return;
      }
      const found = (TAGS || []).find((tag) => Number(tag.id) === id);
      if (found) {
        vet = [...vet, found];
        setSelecionadas(vet);
        sessionStorage.setItem('tagsMsg', JSON.stringify(vet));
      }
    } else {
      vet = vet.filter((tag) => Number(tag.id) !== id);
      setSelecionadas(vet);
      sessionStorage.setItem('tagsMsg', JSON.stringify(vet));
    }
  }

  function verificaTag(tagsId) {
    const result = selecionadas.find((tag) => Number(tag.id) === Number(tagsId));
    return result ? 'tagON' : 'tagOFF';
  }

  function voltar() {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/timeline');
    }
  }

  return (
    <FeedLayout active="timeline">
      <div className="nova-msg-container">
        <div className="feed-top">
          <button type="button" className="btn-voltar" onClick={voltar}>
            <FiArrowLeft size={18} /> {t('pages.message.buttons.back')}
          </button>
          <span>{t('pages.message.title')}</span>
        </div>
        <section className="body">
          <form className="nova-msg-card" onSubmit={enviarMenagem}>
            <div className="clTags" ref={tagsBoxRef}>
              <label>{t('pages.message.labels.tags')}</label>
              <button
                type="button"
                className="tags-select"
                onClick={() => {
                  try {
                    const cached = JSON.parse(sessionStorage.getItem('TAGS'));
                    if (Array.isArray(cached)) setTAGS(cached);
                  } catch (err) {}
                  setTagsOpen(!tagsOpen);
                }}
              >
                <span>
                  {selecionadas.length
                    ? `${selecionadas.length} selecionada${selecionadas.length > 1 ? 's' : ''}`
                    : t('pages.message.select.tags')}
                </span>
                <FiChevronDown />
              </button>
              {tagsOpen && (
                <div className="tags-panel">
                  <div className="tags-search">
                    <FiSearch />
                    <input
                      type="text"
                      value={tagQuery}
                      onChange={(e) => setTagQuery(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') e.preventDefault();
                      }}
                      placeholder={t('pages.message.placeholders.searchTag')}
                      autoFocus
                    />
                  </div>
                  <ul className="tags-list">
                    {(TAGS || [])
                      .filter((tag) => {
                        const q = tagQuery.trim().toLowerCase();
                        if (!q) return true;
                        const bruto = String(tag.name || '').toLowerCase();
                        const amigavel = tagLabel(tag.name).toLowerCase();
                        return bruto.indexOf(q) !== -1 || amigavel.indexOf(q) !== -1;
                      })
                      .map((tag) => (
                        <li
                          key={tag.id}
                          className={verificaTag(tag.id) === 'tagON' ? 'is-on' : ''}
                          onClick={() => selecionaTag(tag.id)}
                        >
                          {tagLabel(tag.name)}
                        </li>
                      ))}
                  </ul>
                </div>
              )}
              {selecionadas.length > 0 && (
                <div className="tags-chosen">
                  {selecionadas.map((tag) => (
                    <button
                      type="button"
                      key={tag.id}
                      className="tag-chip"
                      onClick={() => selecionaTag(tag.id)}
                    >
                      {tagLabel(tag.name)} ×
                    </button>
                  ))}
                </div>
              )}
            </div>
            <label className="nova-msg-text-label" htmlFor="mensagem">
              {t('pages.message.labels.text')}
            </label>
            <textarea
              id="mensagem"
              name="mensagem"
              rows="6"
              value={mensagem}
              onChange={(e) => setMensagem(e.target.value)}
              placeholder={t('pages.message.placeholders.text')}
            />
            <div className="nova-msg-acoes">
              <button type="submit" className="btnPublicar">{t('pages.message.buttons.publish')}</button>
            </div>
          </form>
        </section>
      </div>
    </FeedLayout>
  );
}
